var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDonation(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11044",
    "data-name": "Group 11044",
    transform: "translate(23617 19915)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5456",
    "data-name": "Path 5456",
    d: "M15,0A15,15,0,1,1,0,15,15,15,0,0,1,15,0Z",
    transform: "translate(-23617 -19915)",
    fill: "#ffeaae"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4335",
    "data-name": "Group 4335",
    transform: "translate(-23612 -19907)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3892",
    "data-name": "Group 3892",
    transform: "translate(0.133 1.539)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3885",
    "data-name": "Group 3885",
    transform: "translate(0.356 0.356)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1455",
    "data-name": "Rectangle 1455",
    width: 7.118,
    height: 17.794,
    transform: "translate(0 6.962) rotate(-78)",
    fill: "#ffc629"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3886",
    "data-name": "Group 3886",
    transform: "translate(16.717 3.833)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1456",
    "data-name": "Rectangle 1456",
    width: 7.118,
    height: 1.068,
    transform: "translate(0 6.962) rotate(-78)",
    fill: "#ffa92c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3887",
    "data-name": "Group 3887",
    transform: "translate(0.356 0.356)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1457",
    "data-name": "Rectangle 1457",
    width: 7.118,
    height: 1.068,
    transform: "translate(0 6.962) rotate(-78)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3888",
    "data-name": "Group 3888"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M584.386,694.957a.358.358,0,0,1-.074-.008l-17.4-3.7a.356.356,0,0,1-.274-.422l1.48-6.962a.356.356,0,0,1,.422-.274l17.4,3.7a.356.356,0,0,1,.274.422l-1.48,6.962a.355.355,0,0,1-.348.282ZM567.4,690.628l16.708,3.551,1.332-6.266-16.708-3.551Z",
    transform: "translate(-566.626 -683.584)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3889",
    "data-name": "Group 3889",
    transform: "translate(11.783 3.834)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M828.264,773.091a.354.354,0,0,1-.074-.008l-3.481-.74a.356.356,0,1,1,.148-.7l3.193.678a1.074,1.074,0,0,1,.772-.5l.469-2.207a1.072,1.072,0,0,1-.5-.773l-3.192-.679a.356.356,0,1,1,.148-.7l3.481.74a.356.356,0,0,1,.274.422.356.356,0,0,0,.274.422.356.356,0,0,1,.274.422l-.592,2.785a.354.354,0,0,1-.422.274.358.358,0,0,0-.422.274A.355.355,0,0,1,828.264,773.091Z",
    transform: "translate(-824.427 -767.462)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3890",
    "data-name": "Group 3890",
    transform: "translate(2.185 1.91)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M618.809,731.007a.348.348,0,0,1-.074-.008l-3.481-.74a.356.356,0,0,1-.274-.422.356.356,0,0,0-.274-.422.356.356,0,0,1-.274-.422l.592-2.785a.356.356,0,0,1,.422-.274.356.356,0,0,0,.268-.05.352.352,0,0,0,.154-.224.356.356,0,0,1,.422-.274l3.481.74a.356.356,0,1,1-.148.7l-3.192-.678a1.075,1.075,0,0,1-.773.5l-.469,2.207a1.073,1.073,0,0,1,.5.772l3.192.679a.356.356,0,0,1-.074.7Z",
    transform: "translate(-614.423 -725.378)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3891",
    "data-name": "Group 3891",
    transform: "translate(7.646 3.209)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M735.921,758.753a1.841,1.841,0,0,1-.384-.041,1.983,1.983,0,0,1-1.342-1.055,2.711,2.711,0,0,1-.229-1.825,2.335,2.335,0,0,1,2.607-1.993h0a2.337,2.337,0,0,1,1.571,2.881A2.423,2.423,0,0,1,735.921,758.753Zm.265-4.243a1.714,1.714,0,0,0-1.523,1.47,2,2,0,0,0,.162,1.345,1.285,1.285,0,0,0,.86.691,1.824,1.824,0,0,0,.74-3.481h0A1.144,1.144,0,0,0,736.186,754.51Z",
    transform: "translate(-733.903 -753.799)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3900",
    "data-name": "Group 3900",
    transform: "translate(0.678 3.311)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3893",
    "data-name": "Group 3893",
    transform: "translate(0.356 0.356)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1458",
    "data-name": "Rectangle 1458",
    width: 17.794,
    height: 7.118,
    fill: "#ffc629"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3894",
    "data-name": "Group 3894",
    transform: "translate(17.082 0.356)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1459",
    "data-name": "Rectangle 1459",
    width: 1.068,
    height: 7.118,
    fill: "#ffa92c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3895",
    "data-name": "Group 3895",
    transform: "translate(0.356 0.356)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1460",
    "data-name": "Rectangle 1460",
    width: 1.068,
    height: 7.118,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3896",
    "data-name": "Group 3896"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M596.716,730.181H578.922a.356.356,0,0,1-.356-.356v-7.117a.356.356,0,0,1,.356-.356h17.794a.356.356,0,0,1,.356.356v7.117A.356.356,0,0,1,596.716,730.181Zm-17.438-.712H596.36v-6.406H579.278Z",
    transform: "translate(-578.566 -722.352)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3897",
    "data-name": "Group 3897",
    transform: "translate(1.779 1.424)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M622.123,758.479h-3.559a.356.356,0,0,1-.356-.356.356.356,0,0,0-.356-.356.356.356,0,0,1-.356-.356v-2.847a.356.356,0,0,1,.356-.356.356.356,0,0,0,.356-.356.356.356,0,0,1,.356-.356h3.559a.356.356,0,1,1,0,.712h-3.264a1.072,1.072,0,0,1-.651.651v2.257a1.073,1.073,0,0,1,.651.651h3.264a.356.356,0,1,1,0,.712Z",
    transform: "translate(-617.497 -753.497)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3898",
    "data-name": "Group 3898",
    transform: "translate(11.744 1.424)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M839.423,758.479h-3.559a.356.356,0,1,1,0-.712h3.264a1.073,1.073,0,0,1,.651-.651v-2.257a1.072,1.072,0,0,1-.651-.651h-3.264a.356.356,0,1,1,0-.712h3.559a.356.356,0,0,1,.356.356.356.356,0,0,0,.356.356.356.356,0,0,1,.356.356v2.847a.356.356,0,0,1-.356.356.356.356,0,0,0-.356.356A.356.356,0,0,1,839.423,758.479Z",
    transform: "translate(-835.508 -753.497)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3899",
    "data-name": "Group 3899",
    transform: "translate(7.118 1.424)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M736.424,758.479a2.521,2.521,0,1,1,2.135-2.491A2.337,2.337,0,0,1,736.424,758.479Zm0-4.271a1.824,1.824,0,1,0,1.424,1.779A1.633,1.633,0,0,0,736.424,754.209Z",
    transform: "translate(-734.289 -753.497)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3908",
    "data-name": "Group 3908",
    transform: "translate(0.133 1.539)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3901",
    "data-name": "Group 3901",
    transform: "translate(0.356 0.356)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1461",
    "data-name": "Rectangle 1461",
    width: 17.794,
    height: 7.118,
    transform: "translate(0 3.699) rotate(-12)",
    fill: "#ffc629"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3902",
    "data-name": "Group 3902",
    transform: "translate(16.717 0.356)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1462",
    "data-name": "Rectangle 1462",
    width: 1.068,
    height: 7.118,
    transform: "translate(0 0.222) rotate(-12)",
    fill: "#ffa92c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3903",
    "data-name": "Group 3903",
    transform: "translate(0.356 3.833)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1463",
    "data-name": "Rectangle 1463",
    width: 1.068,
    height: 7.118,
    transform: "translate(0 0.222) rotate(-12)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3904",
    "data-name": "Group 3904"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M568.461,694.957a.355.355,0,0,1-.348-.282l-1.48-6.962a.356.356,0,0,1,.274-.422l17.4-3.7a.356.356,0,0,1,.422.274l1.48,6.962a.356.356,0,0,1-.274.422l-17.4,3.7A.36.36,0,0,1,568.461,694.957Zm-1.057-7.044,1.332,6.266,16.708-3.551-1.332-6.266Z",
    transform: "translate(-566.626 -683.584)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3905",
    "data-name": "Group 3905",
    transform: "translate(2.185 3.834)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M616.215,773.09a.356.356,0,0,1-.348-.282.352.352,0,0,0-.154-.224.357.357,0,0,0-.268-.05.355.355,0,0,1-.422-.274l-.592-2.785a.356.356,0,0,1,.274-.422.356.356,0,0,0,.274-.422.356.356,0,0,1,.274-.422l3.481-.74a.356.356,0,1,1,.148.7l-3.192.679a1.074,1.074,0,0,1-.5.772l.469,2.207a1.074,1.074,0,0,1,.773.5l3.192-.678a.356.356,0,1,1,.148.7l-3.481.74A.352.352,0,0,1,616.215,773.09Z",
    transform: "translate(-614.423 -767.461)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3906",
    "data-name": "Group 3906",
    transform: "translate(11.783 1.91)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M825.67,731a.356.356,0,0,1-.074-.7l3.192-.678a1.072,1.072,0,0,1,.5-.773l-.469-2.207a1.074,1.074,0,0,1-.772-.5l-3.193.678a.356.356,0,1,1-.148-.7l3.481-.74a.355.355,0,0,1,.422.274.359.359,0,0,0,.422.274.354.354,0,0,1,.422.274l.592,2.785a.356.356,0,0,1-.274.422.356.356,0,0,0-.274.422.356.356,0,0,1-.274.422l-3.481.74A.355.355,0,0,1,825.67,731Z",
    transform: "translate(-824.427 -725.37)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3907",
    "data-name": "Group 3907",
    transform: "translate(7.646 3.209)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M736.184,758.752a2.043,2.043,0,0,1-1.265-.46,2.8,2.8,0,0,1-.723-3.4,1.983,1.983,0,0,1,1.342-1.056,2.337,2.337,0,0,1,2.607,1.993,2.712,2.712,0,0,1-.229,1.825,1.983,1.983,0,0,1-1.341,1.055h0A1.864,1.864,0,0,1,736.184,758.752Zm-.259-4.244a1.162,1.162,0,0,0-.239.025,1.284,1.284,0,0,0-.86.691,2.094,2.094,0,0,0,.533,2.508,1.284,1.284,0,0,0,1.066.282h0a1.284,1.284,0,0,0,.86-.691,2,2,0,0,0,.163-1.345A1.715,1.715,0,0,0,735.925,754.508Z",
    transform: "translate(-733.903 -753.796)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3918",
    "data-name": "Group 3918",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3909",
    "data-name": "Group 3909",
    transform: "translate(0.356 0.356)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1464",
    "data-name": "Rectangle 1464",
    width: 17.794,
    height: 7.117,
    transform: "matrix(0.914, -0.407, 0.407, 0.914, 0, 7.237)",
    fill: "#ffc629"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3910",
    "data-name": "Group 3910",
    transform: "translate(15.636 0.356)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1465",
    "data-name": "Rectangle 1465",
    width: 1.068,
    height: 7.118,
    transform: "matrix(0.914, -0.407, 0.407, 0.914, 0, 0.434)",
    fill: "#ffa92c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3911",
    "data-name": "Group 3911",
    transform: "translate(0.356 7.159)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1466",
    "data-name": "Rectangle 1466",
    width: 1.068,
    height: 7.118,
    transform: "translate(0 0.434) rotate(-24)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3912",
    "data-name": "Group 3912",
    transform: "translate(5.821)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M691.435,663.058a.356.356,0,0,1-.145-.681l13-5.79-2.606-5.852-1.625.724a.356.356,0,0,1-.29-.65l1.95-.869a.356.356,0,0,1,.47.18l2.895,6.5a.356.356,0,0,1-.18.47l-13.329,5.935A.358.358,0,0,1,691.435,663.058Z",
    transform: "translate(-691.078 -649.909)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3913",
    "data-name": "Group 3913",
    transform: "translate(0 2.026)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M566.973,706.671a.355.355,0,0,1-.325-.211l-2.9-6.5a.356.356,0,0,1,.18-.47l11.7-5.211a.356.356,0,0,1,.29.65l-11.379,5.066,2.606,5.852,1.626-.724a.356.356,0,0,1,.289.65l-1.951.869A.361.361,0,0,1,566.973,706.671Z",
    transform: "translate(-563.722 -694.246)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3914",
    "data-name": "Group 3914",
    transform: "translate(12.679 1.303)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M841.482,679.411a.356.356,0,0,1-.145-.681l.65-.289a.356.356,0,1,1,.289.65l-.65.289A.351.351,0,0,1,841.482,679.411Z",
    transform: "translate(-841.125 -678.409)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3915",
    "data-name": "Group 3915",
    transform: "translate(2.494 6.077)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M620.742,788.932a.355.355,0,0,1-.325-.211.356.356,0,0,0-.47-.18.356.356,0,0,1-.47-.181l-1.158-2.6a.356.356,0,0,1,.18-.47.356.356,0,0,0,.18-.47.356.356,0,0,1,.181-.47l3.251-1.447a.356.356,0,0,1,.289.65l-2.981,1.327a1.074,1.074,0,0,1-.33.86l.918,2.061a1.072,1.072,0,0,1,.86.33l2.982-1.327a.356.356,0,1,1,.289.65l-3.251,1.447A.357.357,0,0,1,620.742,788.932Z",
    transform: "translate(-618.289 -782.871)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3916",
    "data-name": "Group 3916",
    transform: "translate(11.308 2.314)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M813.21,706.592a.356.356,0,0,1-.145-.681l2.982-1.328a1.073,1.073,0,0,1,.33-.859l-.918-2.062a1.073,1.073,0,0,1-.86-.33l-2.982,1.327a.356.356,0,0,1-.289-.65l3.251-1.447a.356.356,0,0,1,.47.18.355.355,0,0,0,.47.18.359.359,0,0,1,.272-.007.355.355,0,0,1,.2.187l1.158,2.6a.356.356,0,0,1-.18.47.356.356,0,0,0-.18.47.356.356,0,0,1-.181.47l-3.251,1.448A.358.358,0,0,1,813.21,706.592Z",
    transform: "translate(-811.117 -700.531)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3917",
    "data-name": "Group 3917",
    transform: "translate(7.731 4.788)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M735.328,759.529a2.513,2.513,0,0,1-2.2-1.568,2.708,2.708,0,0,1-.155-1.833,1.934,1.934,0,0,1,2.8-1.246,2.71,2.71,0,0,1,1.258,1.342,2.337,2.337,0,0,1-.937,3.144h0A1.857,1.857,0,0,1,735.328,759.529Zm.615-.485h0Zm-1.117-3.676a1.165,1.165,0,0,0-.476.1,1.285,1.285,0,0,0-.7.855,2,2,0,0,0,.121,1.35,1.633,1.633,0,0,0,2.024,1.047h0a1.634,1.634,0,0,0,.577-2.2,2,2,0,0,0-.922-.993A1.422,1.422,0,0,0,734.826,755.367Z",
    transform: "translate(-732.875 -754.654)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDonation);
export default __webpack_public_path__ + "static/media/donation.90370ad29d63e5f766848f5332fc65a2.svg";
export { ForwardRef as ReactComponent };